import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <main className="min-h-screen bg-cream flex items-center justify-center px-5" data-testid="payment-cancel-page">
      <div className="max-w-md w-full text-center rounded-[2rem] border border-champagne/70 bg-white p-10 shadow-[0_32px_80px_rgb(168,134,27,0.10)]">
        <XCircle size={44} className="mx-auto text-[#8C8C8C]" strokeWidth={1.2} />
        <h1 className="mt-6 font-display text-3xl text-ink">Checkout cancelled</h1>
        <p className="mt-3 text-sm text-[#5C5C5C] leading-relaxed">
          No payment was taken. Your gold eye masks will be waiting whenever you are ready.
        </p>
        <Link
          to="/#shop"
          data-testid="payment-cancel-back-link"
          className="mt-8 inline-flex rounded-full bg-ink text-white font-semibold px-8 py-3.5 hover:bg-gold-deep transition-colors duration-300"
        >
          Return to shop
        </Link>
      </div>
    </main>
  );
}
